import { useNavigate } from "react-router-dom";
import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { mapGoalFormToParams } from "web_myplann/Goals/Mappers/mapGoalFormToParams";
import type { GoalFormPageState } from "web_myplann/Goals/Types/GoalFormPageState";
import type { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const useOpenGoalFormFromInspiration = () => {
	const navigate = useNavigate();

	const openGoalForm = (
		fields: Partial<GoalFormModel>,
		inspirationType: InspirationTypeEnum,
	) => {
		const params = mapGoalFormToParams(fields, inspirationType);
		navigate(`${Routing.Goals.GoalFormCreate.path()}?${params.toString()}`, {
			state: { returnToGoalsList: true } satisfies GoalFormPageState,
		});
	};

	return { openGoalForm };
};
